<template>
  <div class="container white" style="padding:4%">
    <div class="row">
      <div class="col-md-12" style="padding-bottom:3%;">
        <h2>LogBox Practice features</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-3">
        <span class="section-feature-icons-three">
          <i class="fas fa-users"></i>
        </span>
        <p class="feature-texts">
          Demographics
          <br />Sharing
        </p>
      </div>
      <div class="col-md-3">
        <span class="section-feature-icons-three">
          <i class="fas fa-book-medical"></i>
        </span>
        <p class="feature-texts">Clinical Notes</p>
      </div>
      <div class="col-md-3">
        <span class="section-feature-icons-three">
          <i class="fas fa-paste"></i>
        </span>
        <p class="feature-texts">
          Customisable clinical
          <br />templates
        </p>
      </div>
      <div class="col-md-3">
        <span class="section-feature-icons-three">
          <i class="fas fa-notes-medical"></i>
        </span>
        <p class="feature-texts">
          Patient
          <br />Questionnaires/
          <br />PROMS
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <span class="section-feature-icons-three">
          <i class="fas fa-credit-card"></i>
        </span>
        <p class="feature-texts">
          Medical Billing
          <br />system integration
        </p>
      </div>
      <div class="col-md-3">
        <span class="section-feature-icons-three">
          <i class="fas fa-file-upload"></i>
        </span>
        <p class="feature-texts">
          Document
          <br />management and
          <br />Multimedia Storage
        </p>
      </div>
      <div class="col-md-3">
        <span class="section-feature-icons-three">
          <i class="fas fa-file-contract"></i>
        </span>
        <p class="feature-texts">Consent to practice</p>
      </div>
      <div class="col-md-3">
        <span class="section-feature-icons-three">
          <i class="fas fa-comment"></i>
        </span>
        <p class="feature-texts">Messaging Module</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <span class="section-feature-icons-three">
          <i class="fas fa-clinic-medical"></i>
        </span>
        <p class="feature-texts">
          Pre-admissions
          <br />with integration to
          <br />Hospitals
        </p>
      </div>
      <div class="col-md-3">
        <span class="section-feature-icons-three">
          <i class="fas fa-file-medical-alt"></i>
        </span>
        <p class="feature-texts">
          Theatre Lists and
          <br />Waiting Lists
        </p>
      </div>
      <div class="col-md-3">
        <span class="section-feature-icons-three">
          <i class="fas fa-server"></i>
        </span>
        <p class="feature-texts">
          Database creation and
          <br />management
        </p>
      </div>
      <div class="col-md-3">
        <span class="section-feature-icons-three">
          <i class="fas fa-chart-line"></i>
        </span>
        <p class="feature-texts">Reports and analytics</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'practice-features',
};
</script>
<style scoped>
.section-title {
  font-size: 56pt;
}

.section-feature-icons-three {
  font-size: 20pt;
}

.feature-texts {
  font-size: 12pt;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// PracticeFeatures.vue?76c39bbc